import { hasAccount } from './account';
import { hasArray } from './array';
import { hasAsset } from './asset';
import { hasAttribute } from './attribute';
import { hasBlock } from './block';
import { hasBuffer } from './buffer';
import { hasContract } from './contract';
import { hasHeader } from './header';
import { hasInput } from './input';
import { hasOutput } from './output';
import { hasTransaction } from './transaction';
const hasBuiltins = [
    hasArray,
    hasAttribute,
    hasBuffer,
    hasInput,
    hasOutput,
    hasTransaction,
    hasAccount,
    hasAsset,
    hasBlock,
    hasContract,
    hasHeader,
];
export function getHasBuiltins(context, node, type) {
    return hasBuiltins.filter((hasBuiltin) => hasBuiltin(context, node, type));
}

//# sourceMappingURL=getHasBuiltins.js.map
